var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.propsClass},[_c('h2',[_vm._v(_vm._s(_vm.$t("sabre.search-result.box.round-trip-price-per-person"))+" "),_c('strong',[_vm._v(_vm._s(`$${_vm.pricePerPerson}`))])]),_c('h3',[_vm._v(_vm._s(_vm.$t("sabre.search-result.box.total-for-persons", {count: _vm.persons}))+" "+_vm._s(`$${Math.round(_vm.totalPrice)}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }